export const project1 = {
  id: 'senior-it-recruiter',
  name: 'Senior IT Recruiter',
  description: `
      <p>
        Sme softvérová spoločnosť, ktorá okrem vývoja softvéru poskytuje aj špičkové služby voblasti <strong>IT outsourcingu</strong>.
        Našou misiou je <strong>prepájať skúsených IT špecialistov s týmisprávnymi projektmi – rýchlo, efektívne a s dôrazom na kvalitu.</strong>
      </p>

      <p>
        Do nášho tímu hľadáme <strong>Senior IT Recruitera</strong>, ktorý bude zohrávať <strong>kľúčovú úlohu</strong>
        prirozvoji našich služieb, budovaní silnej databázy talentov a úzkej spolupráci sobchodným tímom.
      </p>

      <p class="tw-heading-5"><strong>Čo bude tvojou hlavnou úlohou?</strong></p>

      <p>
        Zabezpečiť kontinuálny rast objednávok na naše IT služby – <strong>minimálne 12 novýchobjednávok ročne.</strong>
        Ako recruiter budeš dôležitým hráčom pri prepájaní IT špecialistov sprojektmi a zároveň neoddeliteľnou súčasťou <strong>Koderia</strong> tímu.
      </p>

      <p class="tw-heading-5"><strong>Tvoje hlavné zodpovednosti</strong></p>

      <ul>
        <li>
          <strong>Zasielanie kvalitných personálnych návrhov</strong> na IT projekty – včas a podľapožiadaviek klienta
        </li>
        <li>
          <strong>Aktívne vyhľadávanie a oslovovanie kandidátov</strong> cez našu databázu (admin Koderia), LinkedIn,
          pracovné portály a ďalšie sourcing kanály
        </li>
        <li>
          <strong>Umiestňovanie kandidátov na vhodné projekty</strong> – v rámci našej internejdatabázy alebo priamo u
          klientov, podľa technických znalostí, jazykovej úrovne apreferencií kandidáta
        </li>
        <li>
          <strong>Zapisovanie všetkých relevantných informácií</strong>  o kandidátoch do internej databázy
        </li>
        <li>Pravidelná <strong>aktualizácia údajov o kandidátoch</strong> v admine Koderia</li>
      </ul>

      <p class="tw-heading-5"><strong>Čo od teba očakávame?</strong></p>
      <ul>
        <li>Skúsenosti s náborom v IT sektore (inhouse, alebo agentúrny recruitment)</li>
        <li>Dobrá orientácia v databázach, sourcing nástrojoch a pracovných portáloch</li>
        <li>Zmysel pre detail a precíznosť pri hodnotení kandidátov</li>
        <li>Skvelé komunikačné schopnosti a tímového ducha</li>
        <li>Orientácia na výsledky – vieš, že každý kandidát môže znamenať novú príležitosť</li>
      </ul>

      <p class="tw-heading-5"><strong>Čo ti ponúkame?</strong></p>
      <ul>
        <li>Spoluprácu na <strong>B2B</strong> s motivačným <storng>výkonnostným ohodnotením</storng></li>
        <li>Slobodu v organizácii práce – dôležité sú výsledky, nie počet hodín</li>
        <li>Silnú podporu od obchodného tímu a delivery koordinátorov</li>
        <li>Príjemný tím a kolegov, na ktorých sa môžeš spoľahnúť</li>
        <li><strong>Príspevok na vzdelávanie</strong> a možnosť odborného rastu</li>
        <li><strong>Multisport karta</strong> na podporu tvojho well-beingu</li>
      </ul>

      <p class="tw-heading-5"><strong>Znie to ako tvoja parketa?</strong></p>

      <p>
        Pošli nám svoj životopis alebo LinkedIn profil a daj nám vedieť, <strong>prečo ťa táto výzvazaujala</strong>.
        Tešíme sa na teba!
      </p>

      <p><strong>Platové podmienky</strong></p>
      <p>od 1 500 € brutto + výkonnostné bonusy</p>
  `,
  language: null,
  city: 'Bratislava',
  partner: null,
  profession: null,
  requiredLevels: [],
  states: [
    {
      value: 'PUBLISHED',
      displayString: 'Published',
    },
  ],
  expertises: [],
  tags: [],
  legalRelationType: null,
  remoteOfficePercentage: null,
  hourlyRate: null,
  mdBudgetFrom: null,
  mdBudgetTo: null,
  monthlySalaryFrom: 1500,
  monthlySalaryTo: null,
  publishedAt: '2025-04-14',
  jobStartDate: '2025-04-14',
  projectLengthInMonths: null,
  responsibleHR: {
    name: 'Kristína Petreková',
    email: 'petrekova@objectify.sk',
  },
}

export const careerProjects = [project1]
